import { css } from '@emotion/css';
import { twoColumnCollapseMediaQuery } from '@snapchat/snap-design-system-marketing';

export const tagsContainerCss = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const supportedPlatformsContainerCss = css`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${twoColumnCollapseMediaQuery} {
    align-items: center;
  }
`;

export const platformsLabelCss = css`
  opacity: 0.5;
`;
